import { render, staticRenderFns } from "./DigitalCalledDetailGrid.vue?vue&type=template&id=3bd48776&scoped=true&"
import script from "./DigitalCalledDetailGrid.vue?vue&type=script&lang=js&"
export * from "./DigitalCalledDetailGrid.vue?vue&type=script&lang=js&"
import style0 from "./DigitalCalledDetailGrid.vue?vue&type=style&index=0&id=3bd48776&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd48776",
  null
  
)

export default component.exports